import request from '@/utils/request'
import type { AxiosResponse } from 'axios'
import type { LaravelPaginated, LaravelResource } from '../types'
import type { User } from '@/models/User'

interface ListQueryArg {
  page?: number | null
  limit?: number | null
}

interface UserFilter {
  [key: string]: string | undefined
}

/** GET /api/v2/users/{id} */
export function getUserById(
  id: string,
): Promise<AxiosResponse<LaravelResource<User>>> {
  return request({
    url: '/api/v2/users/' + id,
    method: 'get',
  })
}

/** GET /api/v2/users — paginated */
export function getUsers(
  list_query?: ListQueryArg | null,
  filter?: UserFilter | null,
  search?: string | null,
  unscoped: boolean = true,
): Promise<AxiosResponse<LaravelPaginated<User>>> {
  const query_params: string[] = []
  if (list_query?.page) query_params.push('page=' + list_query.page)
  if (list_query?.limit) query_params.push('limit=' + list_query.limit)
  if (filter) {
    for (const [key, value] of Object.entries(filter)) {
      if (value !== undefined) query_params.push('filter[' + key + ']=' + value)
    }
  }
  query_params.push('unscoped=' + unscoped)
  if (search) query_params.push('search=' + search)
  return request({
    url: '/api/v2/users/?' + query_params.join('&'),
    method: 'get',
  })
}
